<h1 matDialogTitle
    translate>
    package_upgrade_modal_title
</h1>

<mat-dialog-content class="nuget-upgrade-version-modal-container">
    <ng-container *uiContentLoading="loading$ | async">

        <ng-container *ngIf="totalPackagesToUpgrade > 0; else noPackages">
            <p translate>package_upgrade_modal_description</p>
        </ng-container>
        <ng-template #noPackages>
            <p translate>package_upgrade_modal_description_no_proccesses</p>
        </ng-template>

        <ng-container *ngFor="let pkg of packageList">
            <ng-container *ngIf="!!pkg.processes.length">
                <strong>{{ pkg.id }}</strong>
                <p>{{ 'package_upgrade_uploaded_version' | translate }} <strong>{{ pkg.version }}</strong></p>
                <mat-expansion-panel #matExpansionPanel
                                     data-cy="nuget-package-expansion">
                    <mat-expansion-panel-header cdkTrapFocus>
                        <mat-panel-title>
                            <mat-checkbox #checkbox="matCheckbox"
                                          [disabled]="!matExpansionPanel.expanded"
                                          [checked]="checkedAll(pkg.id)"
                                          [indeterminate]="indeterminate(pkg.id)"
                                          (click)="$event.stopPropagation();"
                                          (change)="toggleAll(checkbox, pkg.id)"
                                          data-cy="nuget-upgrade-all-checkbox">
                            </mat-checkbox>
                            <label class="text-ellipsis"
                                   [translateParams]="{
                                        count: pkg.processes.length
                                   }"
                                   translate>
                                package_upgrade_modal_process_count
                            </label>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-selection-list>
                        <mat-list-option #option="matListOption"
                                         *ngFor="let process of pkg.processes"
                                         [selected]="selection.isSelected(process)"
                                         [checkboxPosition]="'before'"
                                         [matTooltip]="processLabel(process)"
                                         (keyup.enter)="selection.toggle(process)"
                                         (keyup.space)="selection.toggle(process)"
                                         (click)="selection.toggle(process)"
                                         data-cy="nuget-upgrade-single-checkbox">
                            <p class="text-ellipsis">
                                {{ processLabel(process) }}
                            </p>
                        </mat-list-option>
                    </mat-selection-list>
                </mat-expansion-panel>
            </ng-container>
        </ng-container>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-dialog-close
            mat-button
            type="button"
            data-cy="nuget-version-close">
        {{ 'modal_action_close' | translate }}
    </button>
    <button *ngLet="submitting$ | async as submitting"
            [spinnerButtonLoading]="submitting"
            [disabled]="submitting || selection.isEmpty()"
            (click)="onUpgradeVersion()"
            ui-spinner-button
            mat-flat-button
            color="primary"
            type="submit"
            data-cy="nuget-version-upgrade">
        {{ 'package_upgrade_upgrade' | translate }}
    </button>
</mat-dialog-actions>
